import React from 'react';
import HeaderCourseMaterials from './Headers';
import CourseMaterialsItem from "./CourseMaterialsItem";
import TablePagination from 'components/Pagination/TablePagination';

const CourseMaterialsList = ({
	courseMaterials,
	paginationProps,
	editMaterial,
	checkItem,
	checkedIds,
}) => {
	return (
		<table>
			<HeaderCourseMaterials />
			{courseMaterials.map(material => (
				<CourseMaterialsItem
					key={material.id}
					material={material}
					editMaterial={editMaterial}
					checkItem={checkItem}
					checkedIds={checkedIds}
				/>
			))}
      <tr>
        <td colSpan="9">
          <TablePagination
            {...paginationProps}
          />
        </td>
      </tr>
		</table>
	)
}

export default CourseMaterialsList;


// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/CourseMaterials/CourseMaterialsList.jsx